import React, { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Sidenav from "Common/Components/examples/Sidenav";
import theme from "Common/hooks/assets/theme";
import ManagerRoutes from "PlatForms/OrgLMS/Routes/ManagerRoutes/ManagerRoutes";
import { useSoftUIController } from "Common/hooks/context";
// import brand from 'src/assets/images/logo-ct.png'
import brand from "Common/hooks/assets/images/lmsLogo1.png";
import Login from "Common/Auth/SignIn";
import DashboardLayout from "Common/Components/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "Common/Components/examples/Navbars/DashboardNavbar";
import { showSidebar } from "Common/Client/routeUtils";
import { getRoutes } from "Common/Client/routeUtils";
import PerformanceReviewForm from "../PerformanceReview/PerformanceReview";
import PerformanceReviewReport from "../PerformanceReview/PerformanceReviewReport";
import Register from "Common/Auth/SignUp";
import ManagerProfile from "../Profile/Profile";
import EmployeeSearch from "../NewEmployees/newEmployees";
import InviteEmployees from "../NewEmployees/InviteEmployees";
import TrainingStatusReport from "../TrainingStatusReport/TrainingStatusReports";
import ReportDetail from "../TrainingStatusReport/ReportDetail";
import CheckReviews from "../PerformanceReview/CheckReviews";
import PerformanceReviewDISCReport from "../PerformanceReview/PerfomanceReviewDISC";
import TrianingRecomends from "../TrainingStatusReport/TrainingRecomends";

function ManagerContent() {
  const [controller] = useSoftUIController();
  const { layout, sidenavColor } = controller;
  const location = useLocation();

  useEffect(() => {
    sessionStorage.setItem("currentPath", location.pathname);
  }, [location.pathname]);

  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {layout === "dashboard" && showSidebar && (
          <>
            <Sidenav
              color={sidenavColor}
              brand={brand}
              brandName="Manager"
              routes={ManagerRoutes}
            />
          </>
        )}
        <DashboardLayout>
          <DashboardNavbar />
          <Routes>
            {getRoutes(ManagerRoutes)}
            <Route path="*" element={<Navigate to="/manager-dashboard" />} />
            <Route path="/login" name="Login" element={<Login />} />
            <Route path="/register" name="Register" element={<Register />} />
            <Route path="/manager-profile" name="Manager Profile" element={<ManagerProfile />} />
            <Route
              path="/performance-review"
              name="Performance Review Form"
              element={<PerformanceReviewForm />}
            />
            <Route
              path="/performance-review-report"
              name="Performance Review Report"
              element={<PerformanceReviewReport />}
            />
            <Route
              path="/check-reviews"
              name="Check Performance Reviews"
              element={<CheckReviews />}
            />
            <Route
              path="/perfomance-review-disc-assessment"
              name="perfomance-review-disc-assessment"
              element={<PerformanceReviewDISCReport />}
            />
            <Route
              path="/new-employees/search"
              name="Employee Search"
              element={<EmployeeSearch />}
            />
            <Route
              path="/new-employees/invite"
              name="Invite Employees"
              element={<InviteEmployees />}
            />
            <Route
              path="/status-reports"
              name="Training Status Report"
              element={<TrainingStatusReport />}
            />
            <Route path="/training-recomends"
              name="Training Recomends"
              element={<TrianingRecomends />}
            />
            <Route path="/report-Detail/:id" element={<ReportDetail />} />

          </Routes>
        </DashboardLayout>
      </ThemeProvider>
    </>
  );
}
export default ManagerContent;
